<template>
  <div>
    <div class="el-header">
      <nav class="header">
        <div class="header-main">
          <img src="@/assets/logo.png" />
        </div>
        <ul class="header-center" v-if="user.jrwyToken && clientWidth > 750">
          <li><a href="https://www.juranguanjia.com">首页</a></li>
          <li>
            <a href="https://www.juranguanjia.com/about.html">关于我们</a>
          </li>
          <li>
            <a href="https://www.juranguanjia.com/product.html">服务产品</a>
          </li>
          <li>
            <a href="https://www.juranguanjia.com/bizreg.html">合作加盟</a>
          </li>
          <li>
            <a href="https://www.juranguanjia.com/contact.html">联系我们</a>
          </li>
        </ul>
        <div class="header-right">
          <el-dropdown
            trigger="hover"
            @command="handleCommand"
            v-if="user && AuthjrwyToken"
          >
            <img
              :src="user.avatarUrl ? user.avatarUrl : avatarUrl"
              alt
              class="el-dropdown-link"
              @click="toIndex"
            />
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item command="password">修改密码</el-dropdown-item>
              <el-dropdown-item divided command="exit"
                >退出登录</el-dropdown-item
              >
              <el-dropdown-item divided command="supply" v-if="showSupply"
                >前往供应商后台</el-dropdown-item
              >
              <el-dropdown-item divided command="service" v-if="showService"
                >前往服务商后台</el-dropdown-item
              >
            </el-dropdown-menu>
          </el-dropdown>
          <img :src="require('@/assets/headPic/website_black.png')" v-else />
        </div>
      </nav>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import { loginApi } from "@/api";
import cryptoPhp from "../../libs/common/cryptoPhp"; // 加密解密文件
import store from "@/store";
export default {
  data() {
    return {
      avatarUrl: require("@/assets/defaultLogo.png"),
      AuthjrwyToken: "",
      clientWidth: null
    };
  },
  computed: {
    ...mapGetters(["user", "meta"]),
    isIdentityList() {
      let identityList = [];
      for (let i in this.user.identityList) {
        if (this.user.identityList[i].userType === 2) {
          identityList.push(this.user.identityList[i]);
        } else if (this.user.identityList[i].userType === 4) {
          identityList.push(this.user.identityList[i]);
        } else if (this.user.identityList[i].userType === 5) {
          identityList.push(this.user.identityList[i]);
        }
      }
      return identityList;
    },
    showEngineer() {
      let flag = false;
      for (let i in this.user.identityList) {
        if (
          this.user.identityList[i].userType === 2 &&
          this.user.identityList[i].auditStatus === 1
        ) {
          flag = true;
          break;
        }
      }
      return flag;
    },
    showSupply() {
      let flag = false;
      for (let i in this.user.identityList) {
        if (
          this.user.identityList[i].userType === 5 &&
          this.user.identityList[i].auditStatus === 1
        ) {
          flag = true;
          break;
        }
      }
      return flag;
    },
    showService() {
      let flag = false;
      for (let i in this.user.identityList) {
        if (
          this.user.identityList[i].userType === 4 &&
          this.user.identityList[i].auditStatus === 1
        ) {
          flag = true;
          break;
        }
      }
      return flag;
    },
    showControl() {
      let flag = false;
      for (let i in this.user.identityList) {
        if (
          (this.user.identityList[i].userType === 2 ||
            this.user.identityList[i].userType === 4 ||
            this.user.identityList[i].userType === 5) &&
          this.user.identityList[i].auditStatus === 1
        ) {
          flag = true;
          break;
        }
      }
      return flag;
    }
  },
  mounted() {
    this.clientWidth = document.body.clientWidth;
  },
  methods: {
    ...mapActions({
      USER_SIGNOUT: "USER_SIGNOUT"
    }),
    toIndex() {
      console.log(this.$route.path);
      if (this.$route.path !== "/index") {
        this.$router.push({
          path: "/"
        });
      }
    },
    handleCommand(command) {
      switch (command) {
        case "exit":
          this.ssologout();
          break;
        case "password":
          this.$router.push({
            path: "/form/changePassword"
          });
          break;
        case "control":
          let jrwyToken = cryptoPhp.Encrypt(this.user.jrwyToken);
          let backUrl = `${
            process.env.VUE_APP_AUTH_URL
          }/optIdentity?jrwyToken=${encodeURIComponent(jrwyToken)}`;
          window.location.href = encodeURI(backUrl);
          break;
        case "supply":
          window.location.href = `${
            process.env.VUE_APP_SUPPLY_URL
          }/signUp?jrwyToken=${this.user.jrwyToken}`;
          break;
        case "service":
          window.location.href = `${
            process.env.VUE_APP_SERVICE_URL
          }/signUp?jrwyToken=${this.user.jrwyToken}`;
          break;
        default:
          console.log("你是咋跳到这儿来的。。");
      }
    },
    toHome(optIdentity) {
      // https://www.juranguanjia.com
      if (store.state.Auth.jrwyToken) {
        let jrwyToken = cryptoPhp.Encrypt(store.state.Auth.jrwyToken);
        let backUrl = "";
        if (optIdentity) {
          backUrl = `${
            process.env.VUE_APP_AUTH_URL
          }/optIdentity?jrwyToken=${encodeURIComponent(jrwyToken)}`;
        } else {
          backUrl = `${
            process.env.VUE_APP_AUTH_URL
          }?jrwyToken=${encodeURIComponent(jrwyToken)}`;
        }
        window.location.href = encodeURI(backUrl);
      } else {
        window.location.href = `${process.env.VUE_APP_AUTH_URL}`;
      }
    },
    // 注册账号
    async ssologout() {
      try {
        let params = {
          jrwyToken: JSON.parse(window.localStorage.id_user).jrwyToken,
          userType: 1
        };
        let data = (await loginApi.ssologout(params)).data;
        if (data.statusCode === 200) {
          this.$message.success("退出登录");
          this.USER_SIGNOUT();
          this.$router.push("/login");
        }
      } catch (err) {
        console.error(err);
      } finally {
      }
    }
  },
  created() {
    this.AuthjrwyToken = store.state.Auth.jrwyToken;
  }
};
</script>

<style scoped lang="less">
@import "../../assets/styles/common.less";
.el-header {
  width: 100%;
  background: #fff;
  height: 84 / @h!important;
  padding: 0 40 / @h 0 20 / @h;
  border-bottom: 1 / @h solid #dcdcdc;
  .header {
    width: 990 / @h;
    height: 100%;
    margin: 0 auto;
    overflow: hidden;
    display: flex;
    justify-content: space-between;
    .header-main {
      width: 150 / @h;
      height: 48 / @h;
      margin: 22 / @h 0 21 / @h;
      img {
        width: 100%;
        height: 100%;
      }
    }
    .header-center {
      width: 70%;
      display: flex;
      justify-content: space-between;
      line-height: 3.6rem;
      color: #333;
      font-size: 0.8rem;
      // font-size: 20px;
      a {
        cursor: pointer !important;
        transition: color 0.1s;
      }
      a:hover {
        color: rgba(238, 142, 56, 1);
      }
      li:hover {
        color: rgba(238, 142, 56, 1) !important;
        border-bottom: 4px solid rgba(238, 142, 56, 1);
      }
    }
    .header-right {
      height: 84 / @h;
      line-height: 84 / @h;
      font-size: 18 / @h;
      color: #333;
      img {
        width: 30 / @h;
        vertical-align: middle;
        cursor: pointer;
        display: inline-block;
      }
      .item {
        margin-right: 25 / @h;
        i {
          font-size: 21 / @h;
        }
      }
      .el-dropdown {
        color: #fff;
        width: 40 / @h;
        height: 100%;
        .el-dropdown-link {
          cursor: pointer;
        }
        img {
          border-radius: 20 / @h;
          width: 40 / @h;
          height: 40 / @h;
        }
      }
    }
    .header-right:hover a {
      color: #ee8e38;
    }
  }
}
@media screen and (max-width: 750px) {
  .el-header {
    height: 50 / @h!important;
    .header {
      width: 100%;
      font-size: 8 / @f;
    }
  }
  .header-main {
    width: 85 / @h!important;
    height: 27 / @h!important;
    margin: 12.5 / @h 0 12.5 / @h!important;
    img {
      width: 100%;
      height: 100%;
    }
  }
  .header-right {
    height: 50 / @h!important;
    line-height: 50 / @h!important;
  }
  .el-dropdown {
    color: #fff;
    width: 40 / @h;
    height: 100%;
    display: block !important;
    img {
      border-radius: 15 / @h!important;
      width: 30 / @h!important;
      height: 30 / @h!important;
    }
  }
}
</style>
